import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

interface NotApplicableScoreProps {
  className?: string;
}

const NOT_APPLICABLE_REASON =
  "No susceptibility to this hazard at this location (for Landslide: LHASA class 0-2). " +
  "It is a result, not missing data — it is not scored and is left out of the risk averages and percentages.";

/** Sibling to PendingScore / NoDataScore for a `status: "not_applicable"`
 * cell. Deliberately worded as an outcome ("Not at risk"), not "N/A", which
 * reads as missing data — and styled solid, not dashed, so it can't be taken
 * for the dashed "Pending" / "No data" pills. Carries no Low/0 score on
 * purpose: whether these sites should count as a Low score is the
 * methodology owners' call (Landslide N/A vs Score 1). */
export function NotApplicableScore({ className }: NotApplicableScoreProps) {
  return (
    <Badge
      title={NOT_APPLICABLE_REASON}
      className={cn("border-muted-foreground/30 bg-muted text-muted-foreground", className)}
    >
      Not at risk
    </Badge>
  );
}
